import styled, { css } from 'styled-components';
import media from 'src/styles/Media.styled';
import { scrollBarStyle } from 'src/styles/CommonStyles.styled';

export const NotesContainer = styled.div`
    ${media.smalDevice`
        width: ${({ ipadWidth }) => (ipadWidth ? ipadWidth : '100%')}
    `}

    ${media.mobileDevice`     
        width:${(props) =>
            props.moblieWidth ? props.moblieWidth : '100%'};            
    `};
    height: ${(props) => props.height};
    width: ${(props) => props.width};
    background: ${(props) => props.backGround};
    border-radius: ${(props) => props.borderRadius};
    border: ${(props) => props.border};
    margin: ${(props) => props.margin};
    box-shadow: ${(props) => props.boxShadow};
    /* @media only screen and (width: 768px) and (height: 1024px) and (orientation: portrait) {
        width: 436px;
    }
    @media all and (width: 1024px) and (height: 768px) and (orientation: landscape) {
        width: 583px;
    }
    @media all and (width: 1024px) and (height: 1366px) and (orientation: portrait) {
        width: 605px;
    } */
`;
export const CardHeader = styled.div`
    display: flex;
    margin: ${(props) => props.cardHeaderMargin};
    font-family: 'AvenirNextWorld Demi';
    font-size: ${({ fontSize }) => (fontSize ? fontSize : '18px')};
    &:after {
        content: '${(props) => (props.showAstrisk ? '*' : '')}';
        color: red;
        padding-left: 3px;
    }

    ${media.mobileDevice`     
 
`}
`;
export const ContentBody = styled.div`
    display: flex;
    /* height: 90px; */
    margin: ${(props) => props.contentBodyMargin};
    background: ${(props) => props.contentBodyBackground};
    //border: 2px solid #ebeded;
    border-radius: 6px;
    textarea {
        width: ${(props) => props.textAreaWidth};
        height: ${(props) => props.textAreaHeight};
        border: ${(props) => props.textAreaBorder};
        border-radius: ${(props) => props.textAreaBorderRadius};
    }

    ${({ isTextAreaResize }) =>
        !isTextAreaResize &&
        css`
            /* placeholder styling */
            .p-inputtext {
                font-size: ${({ placeholderFont }) =>
                    placeholderFont ? placeholderFont : ''};
                font-family: ${({ placeholderFontFamily }) =>
                    placeholderFontFamily ? placeholderFontFamily : 'AvenirNextWorld Regular'};
                color: ${({ placeholderFontColor }) =>
                    placeholderFontColor ? placeholderFontColor : ''};
                height: ${({ placeholderHeight }) =>
                    placeholderHeight ? placeholderHeight : ''};
            }
            .p-inputtextarea {
                resize: none;
                -webkit-appearance: none;
                outline: none;
                font-size: 15px;
                font-family: 'AvenirNextWorld Regular';
                line-height: ${({ lineHeight }) =>
                    lineHeight ? lineHeight : '20px'};
            }
            .p-inputtext:enabled:hover {
                border-color: #ced4da;
            }
            .p-inputtext:enabled:focus {
                box-shadow: none;
                border-color: #ced4da;
            }
        `}

    ${({ isScrollBar }) =>
        isScrollBar &&
        css`
            .p-inputtextarea {
                ${scrollBarStyle}
            }
        `}
    
    ${media.mobileDevice`     
    
    `}
`;
export const CardFooter = styled.div`
    display: flex;
    margin: ${(props) => props.cardFooterMargin};
    letter-spacing: 0px;
    font-family: ${(props) =>
        props.helperTextFont
            ? props.helperTextFont
            : 'AvenirNextWorld Regular'};
    font-size: 10px;
    color: #4f4f4f;
    opacity: 1;
    // margin-top: 15px;
    justify-content: ${({ justifyContent }) =>
        justifyContent ? justifyContent : ''};
    ${media.mobileDevice`     
 
`}
`;
